import { atom, useAtom } from "jotai";
import { LatLng } from "../utils/models";

const userLatLngAtom = atom<LatLng | undefined>(undefined);

export const useLocation = () => {
  const [userLatLng, setUserLatLng] = useAtom(userLatLngAtom);
  return { userLatLng, setUserLatLng };
};
